var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'view/ledger-report', 'app-common/view/base', 'template/report/landing.htm', 'template/report/zero-states/income-statement.htm'], function($, core, LedgerReportView, BaseView, landingViewTemplate, zeroStateTemplate) {
  var IncomeStatementReportPage;
  return IncomeStatementReportPage = (function(_super) {

    __extends(IncomeStatementReportPage, _super);

    function IncomeStatementReportPage() {
      IncomeStatementReportPage.__super__.constructor.apply(this, arguments);
    }

    IncomeStatementReportPage.prototype.pageId = 'income-statement';

    IncomeStatementReportPage.prototype.reportType = 'income-statement';

    IncomeStatementReportPage.prototype.initialize = function(options, params) {
      var _this = this;
      this.loadingPromise = this.refreshMetadata();
      return this.loadingPromise.always(function(data) {
        var features, hasStatement, ledgerCategories;
        _this.settingsModel = core.getModel('clientsettings');
        features = _this.settingsModel.get('features') || [];
        if (!core.isCurrentClientBookkeeper() && (!_this.hasClosedReportsIn(data) && features.zeroStatesReports)) {
          hasStatement = core.getEarliestStatementTime() !== null;
          return BaseView.prototype.render.call(_this, _.template(zeroStateTemplate, {
            core: core,
            hasStatement: hasStatement
          }));
        } else {
          ledgerCategories = [
            {
              id: 'revenues',
              title: 'Revenues',
              mainappId: '6'
            }, {
              id: 'cogsexpenses',
              title: 'Cost of Sales',
              mainappId: '8'
            }, {
              id: 'grossprofit',
              title: 'Gross Profit',
              singleLine: true
            }, {
              id: 'operatingexpenses',
              title: 'Operating Expenses',
              mainappId: '7'
            }, {
              id: 'netprofit',
              title: 'Net Profit',
              singleLine: true
            }
          ];
          options = _.extend(options, {
            title: 'Income Statement',
            icon: 'ss-files ss-gizmo',
            features: ['date-range', 'edit', 'search', 'overview'],
            ledgerCategories: ledgerCategories,
            template: landingViewTemplate,
            url: function(clientId, from, to, page, ledgerId) {
              return "view/json/" + clientId + "/" + ledgerId + "/" + from + "/" + to + "?page=" + page + "&results-per-page=50";
            },
            ledgersUrl: function(clientId, from, to) {
              return "income-statement/json/" + clientId + "/" + from + "/" + to;
            }
          });
          return IncomeStatementReportPage.__super__.initialize.call(_this, options, params);
        }
      });
    };

    return IncomeStatementReportPage;

  })(LedgerReportView);
});
